import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ExclamationTriangleIcon, ChevronRightIcon } from "@heroicons/react/24/outline";

/**
 * Shown when the bank paywall redirects back after the user canceled
 * payment. Premium Tailwind redesign matching the "something didn't work"
 * empty-state pattern (amber icon circle instead of PaymentFailed's red
 * one, since this isn't an error — just a canceled attempt).
 *
 * Logic/links preserved exactly: no local state or API calls, only a link
 * back to /account/orders.
 */
const PaymentCanceled = () => {
  const { t } = useTranslation();
  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-container flex-col items-center justify-center px-4 py-20 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-amber-50">
        <ExclamationTriangleIcon className="h-10 w-10 text-amber-500" />
      </div>
      <h1 className="mt-6 font-display text-2xl font-bold text-ink sm:text-3xl">
        {t('payment.canceledTitle')}
      </h1>
      <p className="mt-2.5 max-w-md text-sm text-ink-muted sm:text-base">
        {t('payment.canceledBody')}
      </p>
      <Link
        to="/account/orders"
        className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand-500 px-6 py-3 text-sm font-semibold text-white shadow-card transition-colors hover:bg-brand-600"
      >
        {t('payment.backToBookings')}
        <ChevronRightIcon className="h-4 w-4 rtl:rotate-180" />
      </Link>
    </div>
  );
}

export default PaymentCanceled;
